import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Card, Link, Container, Typography } from '@material-ui/core';

import { SelfRegForm } from '../components/authentication/selfregister';
import AuthLayout from '../layouts/AuthLayout';

import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import AuthSocial from '../components/authentication/AuthSocial';
import SelfRegSign from '../components/authentication/selfregister/SelfRegSign';
import { useSettingContext } from '../context/setting_context';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function SelfRegSignature() {
  const { subsAmount, assureAmount } = useSettingContext();
  return (
    <RootStyle title="Register | ZIMTA">
      {/* <AuthLayout>
        Already have an account? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
          Login
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Sign Registration Form
          </Typography>
          <img alt="register" src="/static/illustrations/illustration_register.png" />
        </SectionStyle>
      </MHidden>

      <Container>
        {/* <ContentStyle> */}
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" gutterBottom>
            Accept SSB Monthly Deduction
          </Typography>
          <Typography variant="article" gutterBottom>
            <Box>
              To accept the monthly membership subscription of <strong>US$ ${subsAmount}</strong>{' '}
              and Provident fund of <b>US$ ${assureAmount}</b>,{' '}
              <b>
                please{' '}
                <b>
                  <font color="red">Sign in the Box </font>
                </b>
                and enter OTP{' '}
              </b>
              sent to your phone below.{' '}
              <b>
                <font color="red">Alternatively</font>
              </b>
              , Click the{' '}
              <b>
                <font color="red">Print and Sign</font>
              </b>{' '}
              button below to print the agreeement and email it to membership@zimta.co.zw.
            </Box>
          </Typography>
        </Box>

        {/* <AuthSocial /> */}

        <SelfRegSign />

        <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
          By registering, I agree to ZIMTA&nbsp;
          <Link underline="always" sx={{ color: 'text.primary' }}>
            Terms of Service
          </Link>
          &nbsp;and&nbsp;
          <Link underline="always" sx={{ color: 'text.primary' }}>
            Privacy Policy
          </Link>
          .
        </Typography>

        {/* <MHidden width="smUp">
          <Typography variant="subtitle2" sx={{ mt: 3, textAlign: 'center' }}>
            Already have an account?&nbsp;
            <Link to="/login" component={RouterLink}>
              Login
            </Link>
          </Typography>
        </MHidden> */}
      </Container>
    </RootStyle>
  );
}
